import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MultiChoiceService } from '../question-types';

@Injectable({ providedIn: 'root' })
export class QuestionFormUtilityService {
  constructor(private multiChoiceService: MultiChoiceService) {}

  public getInvalidFormControls(
    form: UntypedFormGroup | UntypedFormArray,
    questionTypeId: number
  ): string[] {
    let invalidControls: string[] = [];
    if (typeof questionTypeId === 'number' && !questionTypeId) {
      return this.multiChoiceService.getInvalidFormControls(form as UntypedFormGroup);
    }

    if (form instanceof UntypedFormGroup) {
      for (let item in form.controls) {
        const ctrl = form.controls[item] as UntypedFormArray | UntypedFormGroup;
        if (ctrl instanceof UntypedFormControl) {
          if (ctrl.invalid) {
            ctrl.markAsTouched();
            invalidControls.push(form.getRawValue()?.uniqueId);
          }
        } else {
          invalidControls.push(
            ...this.getInvalidFormControls(ctrl, questionTypeId)
          );
        }
      }
    } else if (form instanceof UntypedFormArray) {
      for (let i = 0; i < form.controls.length; i++) {
        const ctrl = form.controls[i];
        if (ctrl instanceof UntypedFormControl) {
          if (ctrl.invalid) {
            ctrl.markAsTouched();
            invalidControls.push(i.toString());
          }
        } else {
          invalidControls.push(
            ...this.getInvalidFormControls(
              ctrl as UntypedFormArray | UntypedFormGroup,
              questionTypeId
            )
          );
        }
      }
    }

    return invalidControls;
  }
}
